import React from "react";
import Calendar from "../../../components/calendar";
import StyledCalendarHomePage from "./styles";

const CalendarHomePage = () => {
  const onChangeHandler = () => {};

  return (
    <StyledCalendarHomePage>
      <Calendar />
    </StyledCalendarHomePage>
  );
};

export default CalendarHomePage;
